import tracker from '../../components/tracker/publish'
import Phrase from '../../libs/translationsUtils/phrase'
import Analytics from '../analytics/Analytics'

const trackerHandler = (title, url, idx, quicklinkDestination, quicklinkType, isKnowledgeBase) => {
  let eventLabel
  if (isKnowledgeBase) {
    eventLabel = {
      'Title': title,
      'Link': url,
      'Type': 'knowledge base parent'
    }
    Analytics.send('Homepage', 'Category clicked', eventLabel)
    return
  }

  eventLabel = {
    Title: title,
    Position: idx + 1,
    Link: url
  }
  Analytics.send('Homepage', 'Quick link clicked', eventLabel)

  tracker.trackEvent('userevent', {
    type: 'Quick Link Clicked',
    quick_link_title: title,
    quick_link_url: url,
    quick_link_position: idx + 1,
    quick_link_destination: quicklinkDestination,
    quick_link_type: quicklinkType
  })
}

const QuickLink = props => {
  const { item, borderRadius, enableBorder, isVisibleDesktop, isKnowledgeBase } = props
  let { idx } = props
  const { icon_src, title, url, target, description, subforums } = item
  const image_src = isKnowledgeBase ? item.thumbnailUrl : item.image_src
  const style = { borderRadius: borderRadius ? borderRadius + 'px' : '0' }
  const hasNoVisualsClassName = !icon_src && !image_src ? 'quicklink__box__novisual' : ''
  const quicklinkHeroClassName = icon_src ? 'padding__icon quicklink__hero' : 'quicklink__hero'
  const quicklinkDestination = url.indexOf(window.location.hostname) > -1 ? 'internal' : 'external'
  const urlTarget = target ? '_blank' : ''
  let quicklinkBoxClassName = ''
  quicklinkBoxClassName += enableBorder ? ' has-border' : ''
  quicklinkBoxClassName += !isVisibleDesktop ? ' is-hidden-mobile-up' : ''

  let quicklinkType = ''
  if (image_src) {
    quicklinkType = 'image'
  } else if (icon_src) {
    quicklinkType = 'icon'
  } else {
    quicklinkType = 'text'
  }

  return (
    <li
      class={`featured-topic quicklink__box${quicklinkBoxClassName}`}
      style={style}
      onClick={() => trackerHandler(title, url, idx, quicklinkDestination, quicklinkType, isKnowledgeBase)}>
      <a href={url} class='quicklink__url' target={urlTarget}>
        {icon_src || image_src
          ? <div class={quicklinkHeroClassName} style={{ backgroundImage: `url(${icon_src || image_src})` }} />
          : <div class={hasNoVisualsClassName} /> }
        <div class='quicklink__title'>
          <h3>{title}</h3>
          <p class='text--meta'>{description}</p>

          {isKnowledgeBase &&
            <p class='knowledgeBase__categoriesAmount'>
              {subforums.length} <Phrase p='knowledgebase.category' count={{ number: subforums.length }} />
            </p>
          }
        </div>
      </a>
    </li>
  )
}

export default QuickLink
